import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService implements CanActivate{

  constructor(private Router:Router) { }
  
  canActivate():boolean {
    let user = JSON.parse(localStorage.getItem("access_token"));
    if(user && user['role'] == 'Admin'){
      return true;
    }
    this.Router.navigate(["/Login"]);
    return false;
  }

}
